// Quebra um endereço em texto livre (IA) em campos: rua, número, complemento, bairro, cidade, UF, CEP
const UFS = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];

export const parseAddress = (addr) => {
  if (!addr || typeof addr !== "string") return {};
  const out = { street: "", number: "", complement: "", neighborhood: "", city: "", state: "", zip_code: "" };
  const cep = addr.match(/\bCEP\b\s*:?\s*(\d{5})[.\-\s]?(\d{3})/i)
    || addr.match(/(\d{5})-(\d{3})\b/)
    || addr.match(/(\d{5})\.?(\d{3})\s*$/);
  let rest = addr;
  if (cep) {
    out.zip_code = `${cep[1]}-${cep[2]}`;
    rest = addr.replace(cep[0], "");
  }

  // Segmenta por vírgula, hífen, travessão ou barra
  const segs = rest
    .split(/[,\-–/]/)
    .map((p) => p.trim())
    .filter(Boolean);

  const ufIdx = segs.findIndex((p) => UFS.includes(p.toUpperCase()));
  if (ufIdx >= 0) {
    out.state = segs[ufIdx].toUpperCase();
    if (ufIdx >= 1) out.city = segs[ufIdx - 1];
  }

  const first = segs[0] || "";
  const numMatch = first.match(/^(.*?)[\s,]+(SN|S\/N|\d+)\s*$/i);
  let idx = 1;
  if (numMatch) {
    out.street = numMatch[1].trim();
    out.number = numMatch[2];
  } else {
    out.street = first;
    const nm = (segs[1] || "").match(/^(SN|S\/N|\d+)\b\s*(.*)$/i);
    if (nm) {
      out.number = nm[1];
      if (nm[2]) out.complement = nm[2].trim();
      idx = 2;
    }
  }

  const cityIdx = ufIdx >= 1 ? ufIdx - 1 : segs.length;
  const middle = segs.slice(idx, cityIdx);
  const bairroIdx = middle.findIndex((p) => /^BAIRRO\b/i.test(p));
  if (bairroIdx >= 0) {
    out.neighborhood = middle[bairroIdx].replace(/^BAIRRO\s*:?\s*/i, "").trim();
    middle.splice(bairroIdx, 1);
  } else if (middle.length) {
    out.neighborhood = middle.pop();
  }
  if (middle.length) out.complement = [out.complement, ...middle].filter(Boolean).join(" ");
  return out;
};
